"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptimizedPresentationAwareFilter = void 0;
const ramda_1 = require("ramda");
const utils_1 = require("../../product/hooks/utils");
const presentation_aware_table_filter_utils_1 = require("../../product/hooks/presentation-aware-table-filter.utils");
const reviewed_status_filter_utils_1 = require("../../product/hooks/reviewed-status-filter.utils");
const getOptimizedPresentationAwareFilter = ({ productTreeNode, attributeNode, selectAllMode, selectedProductIds, search, tableFilter, hasLockedProducts, includeAttributeStatuses = true, reviewStatus, }) => {
    var _a;
    if (!selectAllMode && selectedProductIds.length) {
        return { product: { id: { in: selectedProductIds } } };
    }
    // Strip the reviewed-status item before building the base filter — it maps to the top-level
    // `isReviewed` field, not to a ProductFilter label attribute.
    const { filteredTableFilter, reviewedFilterItem } = (0, reviewed_status_filter_utils_1.stripReviewedStatusFilter)(tableFilter !== null && tableFilter !== void 0 ? tableFilter : { items: [], logicOperator: 'and' });
    const isReviewed = (0, reviewed_status_filter_utils_1.buildIsReviewedFilter)(reviewedFilterItem, reviewStatus);
    const filter = (0, presentation_aware_table_filter_utils_1.generatePresentationAwareProductFilter)(filteredTableFilter, includeAttributeStatuses);
    const { title, isTerminalNode } = productTreeNode !== null && productTreeNode !== void 0 ? productTreeNode : {};
    const terminalNodeName = isTerminalNode ? title : null;
    const selectedAttributeFilter = attributeNode
        ? (0, utils_1.createPresentationFilterFromAttributeNode)(attributeNode)
        : null;
    const categoryFilter = isTerminalNode
        ? { product: { attributes: [(0, utils_1.getCategoriesFilter)(terminalNodeName)] } }
        : null;
    const mergedFilter = (0, utils_1.mergePresentationAwareFilters)(filter, selectedAttributeFilter, categoryFilter);
    const product = Object.assign({}, ((_a = mergedFilter.product) !== null && _a !== void 0 ? _a : {}));
    if (selectAllMode) {
        if (hasLockedProducts) {
            product.isLocked = { equals: false };
        }
        else if (selectedProductIds.length) {
            product.id = { notIn: selectedProductIds };
        }
    }
    if (search) {
        product.search = search;
    }
    return Object.assign(Object.assign(Object.assign({}, mergedFilter), isReviewed && { isReviewed }), !(0, ramda_1.isEmpty)(product) && { product });
};
exports.getOptimizedPresentationAwareFilter = getOptimizedPresentationAwareFilter;
